import { z } from 'zod';

import { ZodPappersLegalInfo } from '@Common/types/legal_representatives';
import { ZodCountryCode } from '@Common/types/zod/zod-country-code';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const ZodUBODetailsV2 = z.object({
  id: ZodTrimmedString,
  first_name: ZodTrimmedString.nullable(),
  last_name: ZodTrimmedString.nullable(),
  birth_city: ZodTrimmedString.nullable(),
  citizenship: ZodTrimmedString.nullable(),
  country_of_tax_residence: ZodTrimmedString.nullable(),
  birth_date: ZodTrimmedString.nullable(),
  sex: z.enum(['F', 'M']).nullable(),
  country_of_birth: ZodTrimmedString.nullable(),
  street_address: ZodTrimmedString.nullable(),
  address_postal_code: ZodTrimmedString.nullable(),
  city: ZodTrimmedString.nullable(),
});

export const ZodValidUBODetailsBase = z.object({
  first_name: ZodTrimmedString,
  last_name: ZodTrimmedString,
  birth_city: ZodTrimmedString,
  citizenship: ZodCountryCode.nullable(),
  country_of_tax_residence: ZodCountryCode.nullable(),
  legal_info: ZodPappersLegalInfo.optional(),
});
